var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "m50.46,50.44c-10.9856,12.9865-25.1263,11.6682-34.8931,6.8853-.3134-.1535-.4574-.5248-.5316-.8658h0c-.1926-.8861.4504-1.7241,1.3547-1.7915,5.1942-.3873,12.9572-2.15,21.7079-9.6086,1.1118-.9477,2.1264-2.0092,3.023-3.1625,4.8861-6.2847,9.1044-14.3883,9.3487-20.9704.0191-.5158.4228-.9361.9386-.9522,3.1225-.0975,2.6958-.2368,2.9494.3666,4.1634,9.9069,2.5163,22.0073-3.8909,30.0972l-.0068.0019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b31c",
    stroke: "#f1b31c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "m53.21,19.66c3.7161-1.2359,6.0438,20.6414-1.9939,30.488-11.8,11.01-23.6641,12.652-36.2541,5.914,25.96,5.489,39.47-15.38,38.25-36.4l-.002-.002Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 52.09,
    x2: 51.52,
    y1: 15.49,
    y2: 11.2,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m25.79,56.55c16.7-2.905,24.45-11.14,26.67-27.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m47.54,54.03c-8.106,7.212-23.05,9.45-32.43,2.757l-.4132-1.901c18.42-2.206,32.78-13.96,35.36-35.55,1.105-.0041,4.645-.3957,4.645-.3957,5.599,15.1,1.754,27.15-7.164,35.08l.0022.0097Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/banana.b4e8dbd2ef1db82c8b37cf7800caad37.svg";
export { ForwardRef as ReactComponent };